import { render, staticRenderFns } from "./ProjectFees.vue?vue&type=template&id=fdab9970"
import script from "./ProjectFees.vue?vue&type=script&lang=js"
export * from "./ProjectFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports